import { createStore, applyMiddleware, compose } from "redux";
import * as modules from "./modules";
import { combineReducers } from "redux";
import ReduxThunk from "redux-thunk";

// import { createLogger } from "redux-logger"; // 리덕스 로거 주석처리.

const reducers = combineReducers(modules);

// 개발 모드일 때만 Redux Devtools를 적용합니다.
const isDev = process.env.NODE_ENV === "development";

// const logger = createLogger(); // 리덕스 로거 주석처리.

const composeEnhancers =
  isDev &&
  typeof window === "object" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancer = composeEnhancers(
  // applyMiddleware(logger, ReduxThunk) // 리덕스 로거 주석처리.
  applyMiddleware(ReduxThunk)
);

const configure = createStore(reducers, enhancer);

export default configure;
